import { useQuery } from "@apollo/client";
import { LoadingOverlay, Select } from "@mantine/core";
import { NON_PAGINATED_GET_MY_SUPPLIERS_Business } from "apollo/queries";
import { useEffect, useState } from "react";

export default function BusinesFilter({ onCardClick, business }) {
  const [dropDownData, setDropDownData] = useState([]);

  const { loading, refetch } = useQuery(
    NON_PAGINATED_GET_MY_SUPPLIERS_Business,
    {
      variables: {
        first: parseInt(1000),
        page: 1,
        status: "ACTIVE",
        search: "",
        ordered_by: [
          {
            column: "CREATED_AT",
            order: "DESC",
          },
        ],
      },

      onCompleted(data) {
        const arr = data.myBusinesses.data.map((item) => ({
          label: item.business_name,
          value: item.business_name,
        }));

        setDropDownData(arr);
      },
    },
  );
  useEffect(() => {
    refetch();
  }, []);
  const handleProductSelect = (value) => {
    onCardClick(value);
  };

  return (
    <>
      {loading && <LoadingOverlay visible={loading} />}
      <Select
        placeholder="Filter By Business"
        data={dropDownData}
        value={business}
        label="Select Business"
        onChange={(value) => {
          handleProductSelect(value);
        }}
        clearable
        searchable
        withinPortal
      />
    </>
  );
}
